// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"7c1d3bf8","404":"4c3adb6c","498":"f6de92b9","787":"6422b11b"}[chunkId] + ".chunk.js";
};